import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "footer",
  class: "container-fluid"
};
const _hoisted_2 = {
  class: "logo"
};
export default {
  __name: 'AppFooter',
  setup(__props) {
    // Vue 3 组合式API - 尾部组件
    // 纯静态组件，无需响应式数据

    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createStaticVNode("<div class=\"logo\" data-v-b3b53b36></div><p class=\"title\" data-v-b3b53b36>大谷物联科技有限公司</p><p class=\"address_tel_fax\" data-v-b3b53b36><span data-v-b3b53b36>地址：深圳市龙岗区坂田街道雅星路8号星河双子塔-西塔1705B</span></p><p class=\"email_wx\" data-v-b3b53b36><span data-v-b3b53b36>邮箱：yangyansong@daguiot.com </span><span data-v-b3b53b36>微信号: szdaguiot</span></p><p class=\"email_wx\" data-v-b3b53b36><span data-v-b3b53b36>Tel：189-2344-6082</span></p>", 5)), _createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, [_createElementVNode("span", null, [_createVNode(_component_router_link, {
        target: "_blank",
        style: {
          "color": "whitesmoke"
        },
        to: "/policy"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("服务协议", -1)]))]),
        _: 1
      })]), _cache[2] || (_cache[2] = _createTextVNode("   ", -1)), _createElementVNode("span", null, [_createVNode(_component_router_link, {
        target: "_blank",
        style: {
          "color": "whitesmoke"
        },
        to: "/privacy"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("隐私政策", -1)]))]),
        _: 1
      })])])]), _cache[4] || (_cache[4] = _createElementVNode("p", null, "经营许可证编号:B1.B2-20250353", -1)), _cache[5] || (_cache[5] = _createElementVNode("p", {
        class: "copy"
      }, [_createTextVNode("备案号:"), _createElementVNode("a", {
        href: "https://beian.miit.gov.cn/",
        style: {
          "color": "#d3d3d3"
        }
      }, "粤ICP备2023131534号-1")], -1))]);
    };
  }
};